import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../components/foundations/Label';
import css from './FormInnerSection.css';

const FormInnerSection = ({ titleKey, descriptionKey, disabledMessageKey, headerRight, children, anchor }) => {
    const hasContent = children && React.Children.count(children) > 0;
    const disabled = !!disabledMessageKey;
    return (
        <div
            className={classNames(css.innerSection, { [css.disabled]: disabled })}
            data-error-anchor={anchor || undefined}
        >
            <div className={classNames(css.innerSectionHeader, { [css.headerNoDivider]: !hasContent })}>
                <div className={css.innerSectionHeaderText}>
                    <Label text={titleKey} type="p" className={css.innerSectionTitle} />
                    {descriptionKey && <Label text={descriptionKey} type="p" />}
                    {disabledMessageKey && <Label text={disabledMessageKey} type="p" className={css.disabledMessage} />}
                </div>
                {headerRight}
            </div>
            {hasContent && <div className={css.innerSectionContent}>{children}</div>}
        </div>
    );
};

FormInnerSection.propTypes = {
    titleKey: PropTypes.string.isRequired,
    descriptionKey: PropTypes.string,
    disabledMessageKey: PropTypes.string,
    headerRight: PropTypes.node,
    children: PropTypes.node,
    anchor: PropTypes.string,
};

export default FormInnerSection;
